import React, { useState, useEffect } from "react";
import { Container, Button, Row, Col, Modal } from "react-bootstrap";
import { useReportContext } from "../_context/ReportContext";
import { getAllCleaners } from "../_utils/resourceAPI";
import { Cleaner } from "../_models/Cleaner.model";
import { blobToBase64 } from "../_utils/utilFunctions";
import emailjs from "@emailjs/browser";

interface EmailSenderProps {
  pdfBlob: Blob | null;
  isEnabled: boolean;
  onEmailSent?: () => void;
}

const EmailSenderCleaners: React.FC<EmailSenderProps> = ({ pdfBlob, isEnabled, onEmailSent }) => {
  const { currentViewingReport } = useReportContext();
  const [recipientEmail] = useState("qa@cnacleaning.com.au");
  const [cleanerEmails, setCleanerEmails] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  useEffect(() => {
    const fetchCleaners = async () => {
      try {
        const response = await getAllCleaners();
        const cleaners: Cleaner[] = response.data;
        const filteredCleaners = cleaners.filter(cleaner =>
          currentViewingReport?.Client?.CleanerIds?.includes(cleaner.Id)
        );
        const emails = filteredCleaners.map(cleaner => cleaner.Email).join(",");
        setCleanerEmails(emails);
      } catch (error) {
        console.error("Error fetching cleaners:", error);
      }
    };

    fetchCleaners();
  }, [currentViewingReport]);

  const sendEmailWithPDF = async () => {
    if (!pdfBlob || !currentViewingReport?.Client) return;

    setModalMessage("Sending email...");
    setShowModal(true);

    try {
      const clientName = currentViewingReport.Client.Name;
      const base64 = await blobToBase64(pdfBlob);
      const cleanedBase64 = base64.replace(/^data:application\/pdf;base64,/, "");

      // Combine cleaner emails with additional CC recipients
      const additionalCCEmails = "ashan.k@cnacleaning.com.au";
      const allCCEmails = [cleanerEmails, additionalCCEmails]
        .filter(email => email && email.trim() !== "")
        .join(",");

      const templateParams = {
        to_email: recipientEmail,
        cc_email: allCCEmails,
        client_name: clientName,
        attachment: cleanedBase64,
      };

      const response = await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID!,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID!,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY!
      );

      console.log("EmailJS response:", response);
      setModalMessage("Email sent to cleaners successfully!");
      onEmailSent?.();
    } catch (error) {
      console.error("EmailJS error:", error);
      setModalMessage("Failed to send email. Please try again later.");
    }
  };

  return (
    <Container className="p-0 m-0">
      <Row className="p-0 m-0">
        <Col className="p-0 m-0">
          <button
            onClick={sendEmailWithPDF}
            className="au-submit-btn hover-trigger rp-bottom-nav-btn"
            style={{ background: "#4B5563", color: "white", border: "none", padding: "10px 20px" }}
            disabled={!pdfBlob || !isEnabled}
          >
            Email Report to Cleaners
          </button>
        </Col>
      </Row>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Report Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default EmailSenderCleaners;
